module.exports = __webpack_public_path__ + "img/SMT_05_Mr_Hagen_Ong.56f74b13.jpg";